<template>
    <div id="home" v-loading.fullscreen.lock="changeLoading">
      <div style="background-color: white; margin: 10px 20px">
        <div class="pos_container_panel" style="padding-left: 2rem">
          <!--search area-->
          <el-form :inline="true" class="demo-form-inline" style="margin-left: 6rem; padding-top: 2rem">
            <el-row class="rowtop" style="padding-top: 2rem">
                <el-col :span="12">
                    <el-form-item label="客户名称：" style="margin-bottom: 0; margin-left: 1rem">
                        <el-input @click="showClientName('search')" readonly v-model="searchForm.client" placeholder="请选择"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
            <el-col :span="24" style="float: right">
              <div class="grid-content bg-purple-light" style="float: right">
                <el-button type="warning" class="harpIDbtn" style="margin-left: 3rem" @click="addHotelMarker()">新增</el-button>
              </div>
            </el-col>
          </el-row>
          </el-form>
          <hr style="margin: 1rem -14rem 0rem;background-color: rgb(241 243 245);height: 0.2rem;border: none;"/>
          <!--table-->
          <el-table :data="tableData" style="width: 90%; margin-top: 50px; margin-left: 100px">
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="customerCode" label="客户编号" align="center"></el-table-column>
            <el-table-column prop="customerName" label="客户名称" align="center"></el-table-column>
            <el-table-column prop="fxMark" label="付迅打标名称" align="center"  width="250"></el-table-column>
            <el-table-column prop="cwtMark.zh-CN" label="CWT打标-中文" align="center" width="250"></el-table-column>
            <el-table-column prop="cwtMark.en" label="CWT打标-英文" align="center"  width="250"></el-table-column>
            <el-table-column prop="toTravcomCode" label="To Travcom Code" align="center"  width="150"></el-table-column>
            <el-table-column :label="$t('ORDERLIST.Operation')" fixed="right" align="center" width="110">
              <template #default="scope">
                <el-button @click="handleDetailClick(scope.row)" type="text" size="small">
                  {{ $t("ORDERLIST.Detail") }}
                </el-button>
                <el-button class="deleteShow" @click="deleteRow(scope.row)" type="text" size="small">
                  {{ $t("ORDERLIST.DELETE") }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-footer style="margin: 1rem 2rem; background-color: #ffffff">
            <el-pagination style="float: right; margin: 1rem 0" background layout="total,prev, pager, next" :page-size="15" @current-change="handleCurrentChange" 
            :total="totalCount" v-model:current-page="Pageone">
            </el-pagination>
          </el-footer>
        </div>
      </div>
      <!--新增 dialog-->
      <el-dialog title="酒店打标" v-model="dialogFormVisible">
        <el-form :model="dataForm" :rules="checkMarkerInput" ref="dataForm">
          <el-form-item prop="customerName" label="客户名称:" :label-width="formLabelWidth">
            <el-input @click="showClientName('add')" :disabled="customerdisabled" readonly v-model="dataForm.customerName" placeholder="请选择" style="width: 58%; margin-left: 85px"></el-input>
          </el-form-item>
          <el-form-item label="付迅打标名称:" :label-width="formLabelWidth" prop="fxMark">
            <el-input v-model="dataForm.fxMark" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
          </el-form-item>
          <el-form-item label="CWT打标-中文:" :label-width="formLabelWidth" prop="cwtMarkCn">
            <el-input v-model="dataForm.cwtMarkCn" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
          </el-form-item>
          <el-form-item label="CWT打标-英文:" :label-width="formLabelWidth" prop="cwtMarkEn">
            <el-input v-model="dataForm.cwtMarkEn" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
          </el-form-item>
          <el-form-item label="To Travcom Code:" :label-width="formLabelWidth" prop="toTravcomCode">
            <el-input v-model="dataForm.toTravcomCode" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="saveHotelMarker">保存</el-button>
            <!-- <el-button @click="cancel()">取消</el-button> -->
          </div>
        </template>
      </el-dialog>
      <!--删除el-dialog-->
      <el-dialog title="" v-model="deletedialogVisible" width="18%">
        <div class="dialog-span-fixed">
          <div>
            <svg-icon icon-class="exclamation" style="vertical-align: -0.5em;"></svg-icon>
            <span style="margin-left:1rem;">请确认是否删除</span>
          </div>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <button class="s_btn btn_dialog" @click="handleDeleteClick">确 定</button>
            <el-button class="btn_dialog" style="padding: 0.2rem 2rem;" @click="cancelDelete">取 消</el-button>
          </span>
        </template>
      </el-dialog>
      <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
      <ClientList :customerDialogVisible = "clientListFlag" @setCustomerFlag = "setCustomerFlag" @customerInfo = "selectClient"></ClientList>
    </div>
  </template>
  
  <script>
  import {
  searchHotelMark,
  savehHotelMark,
  deletehHotelMark
} from "@/api/platformData";
  import ConfirmBoxs from "@/components/confirmBoxs.vue";
  import ClientList from "@/components/ClientList.vue";
  export default {
    name: "HBESyncHotel",
    components: {
        ConfirmBoxs,
        ClientList,
    },
    data() {
      return {
        clientListFlag: false,
        changeLoading: false,
        tableData:[],
        totalCount: 0,
        Pageone: 1,
        confirmMsg: "",
        confirmFlag: false,
        searchForm: {
          client: "",
          hotelCustomerCode:"",
        },
        openClient: "search",
        dataForm:{
          id: "",
          customerCode: "",
          customerName: "",
          fxMark: "",
          cwtMarkCn: "",
          cwtMarkEn: "",
          toTravcomCode: "",
          createdBy: "",
          updateBy: "",
        },
        dialogFormVisible: false,
        formLabelWidth: "150px",
        deletedialogVisible: false,
        customerdisabled: false,
      };
    },
    computed: {
      checkMarkerInput() {
        return {
          customerName:[{ required: true, message: this.$t("MANUAL.VALIDATECUSTOMERNAME"), trigger: ["blur", "change"], }],
          fxMark: [{ required: true, message: "请输入付迅打标名称", trigger: ["blur", "change"], },],
          cwtMarkCn: [
            { required: true, message: "请输入CWT打标中文", trigger: ["blur", "change"],},
            { max: 8, message: this.$t("BANNERINFO.VALIDATELENGTH",{max : 8}), trigger: ["blur", "change"],}
          ],
          cwtMarkEn: [
            { required: true, message: "请输入CWT打标英文", trigger: ["blur", "change"], },
            { max: 15, message: this.$t("BANNERINFO.VALIDATELENGTH",{max : 15}), trigger: ["blur", "change"],}
          ],
          toTravcomCode: [
            { required: true, message: "请输入toTravcomCode", trigger: ["blur", "change"],},
            { max: 50, message: this.$t("BANNERINFO.VALIDATELENGTH",{max : 50}), trigger: ["blur", "change"],},
            { pattern: /^[A-Za-z]*$/, message: "请输入英文",},
          ],
        }
      },
    },
    methods: {
       // 弹出客户姓名窗口方法
       showClientName(type) {
        this.openClient = type;
        this.clientListFlag = true;
       },
       setConfirmFlag(value) {
         this.changeLoading = false;
         this.confirmFlag = value;
       },
      //选择客户
      selectClient(item) {
        if(this.openClient == 'search'){
          this.searchForm.hotelCustomerCode = item.customerCode;
          this.searchForm.client = item.customerName;
          this.searhotelMark(1);
        }else{
          this.dataForm.customerCode = item.customerCode;
          this.dataForm.customerName = item.customerName;
        }
      },
      setCustomerFlag(value) {
        this.clientListFlag = value;
      },
      searhotelMark(currPage){
        let customerParam = {
          params: {
          page: currPage,
          per_page: 10,
          customerCode: this.searchForm.hotelCustomerCode,
          },
        };
        let that = this;
        searchHotelMark(customerParam)
        .then((res) => {
          if(res.code == 200){
            that.tableData = res.data.list;
            that.totalCount = res.data.total;
          }
        })
        .catch(function (error) {
          that.tableData = [];
          that.totalCount = 0;
        });
      },
      //分页
      handleCurrentChange(pageNum) {
        this.searhotelMark(pageNum);
        this.Pageone = pageNum;
      },
      addHotelMarker(){
        //this.dataForm.id = "";
        this.dataForm = {
          id: "",
          customerCode: "",
          customerName: "",
          fxMark: "",
          cwtMarkCn: "",
          cwtMarkEn: "",
          toTravcomCode: "",
          createdBy: "",
          updateBy: "",
        },
        this.customerdisabled = false;
        this.dialogFormVisible = true;
      },
      saveHotelMarker(){
        this.$refs["dataForm"].validate((valid) => {
          if (valid) {
            let param = {
              id: this.dataForm.id,
              customerCode:  this.dataForm.customerCode,
              customerName:  this.dataForm.customerName,
              fxMark:  this.dataForm.fxMark,
              cwtMarkCn:  this.dataForm.cwtMarkCn,
              cwtMarkEn:  this.dataForm.cwtMarkEn,
              toTravcomCode:  this.dataForm.toTravcomCode,
              createdBy: this.dataForm.id == ""? "":this.$objBaseInfo.loginID,
              updateBy:  this.dataForm.id == ""? this.$objBaseInfo.loginID:"",
            }
            savehHotelMark(param)
            .then((res) => {
              if(res.code == 200){
                this.confirmMsg = "保存成功！";
                this.confirmFlag = true;
                this.dialogFormVisible = false;
                this.searhotelMark(1);
              }else{
                this.confirmMsg = res.message;
                this.confirmFlag = true;
              }
            })
            .catch(function (error) {
            });
          }
        })
      },
      handleDetailClick(row){
        this.dataForm.customerCode = row.customerCode;
        this.dataForm.customerName = row.customerName;
        this.dataForm.fxMark = row.fxMark;
        this.dataForm.cwtMarkCn = row.cwtMark["zh-CN"];
        this.dataForm.cwtMarkEn = row.cwtMark.en;
        this.dataForm.toTravcomCode = row.toTravcomCode;
        this.dataForm.id = row.id;
        this.customerdisabled = true;
        this.dialogFormVisible = true;
      },
      deleteRow(row) {
        this.deletedialogVisible = true;
        this.deleteparams = {
          params: {
            id: row.id,
          },
        };
      },
      cancelDelete() {
        this.deletedialogVisible = false;
      },
      async handleDeleteClick() {
        this.deletedialogVisible = false;
        await deletehHotelMark(this.deleteparams)
        .then((res) => {
          if (res.code == 200) {
            this.confirmFlag = true;
            this.confirmMsg = "删除成功";
            this.searhotelMark(1);
          } else {
            this.confirmFlag = true;
            this.confirmMsg = res.message;
          }
        })
        .catch((err) => {
        });
    },
    },
  };
  </script>
  
  <style scoped>
  .pos_container_panel {
    padding: 0 16rem 4rem;
  }
  ::v-deep .dialog-one .el-dialog__body {
    padding: 0px;
  }
  .harpIDbtn {
    width: 10rem;
    height: 3rem;
    padding: 0 !important;
    font-size: 1rem !important;
  }
  </style>
  